import flow from 'lodash/flow';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { Component } from 'react';
import PropTypes from 'prop-types';
import mint from '@tunein/mint';
import { bindActionCreators } from 'redux';
import withAdRegistration from '../../decorators/ads/withAdRegistration';
import withDisplayAdWrapper from '../../decorators/ads/withDisplayAdWrapper';
import webCategory from '../../constants/analytics/categoryActionLabel/web';
import { logCategoryActionLabel } from '../../actions/logging';
import { isCategory, isProfile } from '../../utils/guideItemTypes';
import { MINT_CATEGORY_ID } from '../../constants/ads/location';
import { LocationAndLocalizationContext } from '../../providers/LocationAndLocalizationProvider';

const styles = {
  adContainer: {
    margin: '0',
    textAlign: 'center',
    pointerEvents: 'auto',
    // pointer-events:auto ensures the user can interact with the content of the ad slot,
    // even if the container DisplayAdSlot is rendered in has pointer-events:none
  },
  link: {
    display: 'block',
    cursor: 'default',
    lineHeight: '1px',
    opacity: 0,
  },
};

// disable linting because this needs to be a class or it blows up
// in withAdRegistration call.
// eslint-disable-next-line react/prefer-stateless-function
class DisplayAdSlot extends Component {
  static propTypes = {
    slotName: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    guideId: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
    isProfile: PropTypes.bool,
    userAgent: PropTypes.string,
    loggingActions: PropTypes.shape({
      logCategoryActionLabel: PropTypes.func.isRequired,
    }).isRequired,
  };

  static contextType = LocationAndLocalizationContext;

  componentDidMount() {
    this.updateMintCategoryId();
  }

  componentDidUpdate(prevProps) {
    const { guideId } = this.props;
    if (guideId !== prevProps.guideId) {
      this.updateMintCategoryId();
    }
  }

  componentWillUnmount() {
    mint.clearState('categoryId');
  }

  updateMintCategoryId() {
    const { guideId } = this.props;

    if (isCategory(guideId)) {
      mint.updateState('categoryId', guideId);
      return;
    }

    const mintCategoryId = get(
      this.context,
      ['location', 'state', MINT_CATEGORY_ID],
      '',
    );
    const canSetCategory = mintCategoryId && isCategory(mintCategoryId);

    if (isProfile(guideId) && canSetCategory) {
      mint.updateState('categoryId', mintCategoryId);
      return;
    }

    mint.clearState('categoryId');
  }

  disableAdsAndLog = () => {
    const { loggingActions, userAgent } = this.props;
    mint.disableAds();
    loggingActions.logCategoryActionLabel({
      category: webCategory.category,
      action: webCategory.actions.honeypot,
      label: userAgent,
    });
  };

  render() {
    const { style, id, className } = this.props;

    return (
      <div className={className} style={{ ...styles.adContainer, ...style }}>
        <div id={id} />
        {/* This is a honeypot to catch click bots */}
        <a
          id="ad_unit"
          data-testid="adUnit"
          onClick={this.disableAdsAndLog}
          style={{ ...styles.link }}
          aria-hidden="true"
        >
          --
        </a>
      </div>
    );
  }
}

export function mapDispatchToProps(dispatch) {
  return {
    loggingActions: bindActionCreators({ logCategoryActionLabel }, dispatch),
  };
}

export function mapStateToProps(state) {
  return {
    userAgent: get(state, 'app.userAgent'),
  };
}

export default flow(
  withAdRegistration({
    autoPlay: true,
    refreshOnPageChange: true,
    checkPageChange: true,
  }),
  withDisplayAdWrapper,
  connect(mapStateToProps, mapDispatchToProps),
)(DisplayAdSlot);
